import React from 'react';
import { useNavigate } from 'react-router-dom';

const SessionExpiredModal = ({ isOpen, onClose, currentPath }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  // Handle redirect to login
  const handleRedirect = () => {
    navigate(`/login?next=${encodeURIComponent(currentPath)}`);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
        <h2 className="text-2xl font-bold mb-4 text-[var(--darkBlue)]">Session Expired</h2>
        <p className="mb-6 text-gray-600">
          Your session has expired due to inactivity. Please log in again to continue.
        </p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={handleRedirect}
            className="px-4 py-2 bg-[var(--darkBlue)] text-white rounded hover:bg-blue-700 focus:outline-none"
          >
            Log In
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredModal;